import { render, staticRenderFns } from "./Prospects.vue?vue&type=template&id=5cbcb180"
import script from "./Prospects.vue?vue&type=script&lang=js"
export * from "./Prospects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports